"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numericBoolean = exports.truthy = exports["boolean"] = void 0;

var _debrief = require("debrief");

var _Result = require("lemons/Result");

var _number = require("./number");

var _utils = require("./utils");

/**
 * Decoder that only returns Ok for boolean inputs.  Err otherwise.
 */
var _boolean = function _boolean(blob) {
  return typeof blob === 'boolean' ? (0, _Result.Ok)(blob) : (0, _Result.Err)((0, _debrief.annotate)(blob, 'Must be boolean'));
};
/**
 * Decoder that returns true for all truthy values, and false otherwise.  Never fails.
 */


exports["boolean"] = _boolean;

var truthy = function truthy(blob) {
  return (0, _Result.Ok)(!!blob);
};
/**
 * Decoder that only returns Ok for numeric input values representing booleans.
 * Returns their boolean representation.  Err otherwise.
 */


exports.truthy = truthy;
var numericBoolean = (0, _utils.map)(_number.number, function (n) {
  return !!n;
});
exports.numericBoolean = numericBoolean;